import React from 'react';
import { Outlet } from 'react-router-dom';
import { Toaster } from '@/components/ui/toast';
import { AuthProvider } from '@/contexts/auth-context';
import { FeatureFlagProvider } from '@/providers/feature-flag-provider';
import { QueryProvider } from '@/providers/query-provider';

/**
 * Root layout that provides auth context to the entire application
 * This ensures AuthProvider is inside Router context
 * QueryProvider is placed here to prevent React Query DevTools from flashing during auth redirects
 */
export const RootLayout: React.FC = () => {
  return (
    <QueryProvider>
      <AuthProvider>
        <FeatureFlagProvider>
          <Toaster />
          <Outlet />
        </FeatureFlagProvider>
      </AuthProvider>
    </QueryProvider>
  );
};
